'use strict';

require('@firebase/auth');

//# sourceMappingURL=index.cjs.js.map



//////////////////
// WEBPACK FOOTER
// ./~/firebase/auth/dist/index.cjs.js
// module id = 74
// module chunks = 0